/**
 *  Align cells within the carousel element.
 *  "left", "center", "right"
 */
var cellAlign;
(function (cellAlign) {
    cellAlign["left"] = "left";
    cellAlign["center"] = "center";
    cellAlign["right"] = "right";
})(cellAlign || (cellAlign = {}));
/**
 *  Responsive slider
 *  If the container can't contain all the slides then the carousel will be initialized
 *
 *  ATTENTION
 *  You MUST add the attribute
 *  data-slide to every slide of the slider
 *
 *  @param {string} sliderSelector - querySelector of carousel. Choose [data-carousel] if you want to select all carousel.
 *  @param {cellAlign} cellAlign - Align cells within the carousel element. Choose "left", "center", "right".
 *  @param {boolean} contain - Contains cells to carousel element to prevent excess scroll at beginning or end. Has no effect if wrapAround: true
 *  @param {boolean | number} autoPlay - Automatically advances to the next cell.
 *  @param {boolean} wrapAround - At the end of cells, wrap-around to the other end for infinite scrolling.
 *  @param {number} viewport - An optional parameter to decide at which viewport the carousel should be activated
 *
 */
const initCarousel = (sliderSelector, cellAlign, contain, autoPlay, wrapAround, showArrows, showDots, viewport) => {
    const createdSlidersArray = [];
    if (window.innerWidth <= viewport || !viewport) {
        const arrayCarousel = document.querySelectorAll(sliderSelector);
        if (arrayCarousel && arrayCarousel.length > 0) {
            arrayCarousel.forEach((carouselContainer) => {
                const arraySliderItems = carouselContainer.querySelectorAll("[data-slide]");
                //Max number of slides that could exist into the slider
                const maxNumberOfItems = ((carouselContainer.clientWidth + (arraySliderItems[0].offsetWidth - arraySliderItems[0].clientWidth)) / arraySliderItems[0].offsetWidth);
                //Array of slider's items (How many slide there are on the carousel)
                const actualSliderItemsNumber = arraySliderItems.length;
                //If maxNumberOfItems is less than actualSliderItemsNumber then initialize slider carousel or add a class to center item
                if (actualSliderItemsNumber > maxNumberOfItems) {
                    const flickitySlider = new Flickity(carouselContainer, {
                        on: {
                            ready: function () {
                                carouselContainer.setAttribute("data-carousel", "active");
                            }
                        },
                        //slider options
                        cellAlign: cellAlign.toString(),
                        contain: contain,
                        autoPlay: autoPlay,
                        wrapAround: wrapAround,
                        prevNextButtons: showArrows,
                        pageDots: showDots,
                        imagesLoaded: true,
                        adaptiveHeight: true
                    });
                    //add created slider to list, in order to return it when the function is called
                    createdSlidersArray.push(flickitySlider);
                }
                else {
                    carouselContainer.classList.add("is-not-slider");
                }
            });
        }
    }
    return createdSlidersArray;
};
